import { render, staticRenderFns } from "./paymentScheme.vue?vue&type=template&id=8336030a&scoped=true"
import script from "./paymentScheme.vue?vue&type=script&lang=js"
export * from "./paymentScheme.vue?vue&type=script&lang=js"
import style0 from "./paymentScheme.vue?vue&type=style&index=0&id=8336030a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8336030a",
  null
  
)

export default component.exports